import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    modal: {
      '& .MuiBackdrop-root': {
        background: ' rgba(0, 0, 0, 0.35)',
      },
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: 25,
      padding: '25px',

      minWidth: 640,
      maxWidth: 640,
      minHeight: 404,
      maxHeight: 'calc(100vh - 116px)',

      background: '#fff',
      top: '50%',
      transform: 'translateX(-50%) translateY(-50%)',
      left: 'calc(50%)',
      position: 'absolute',
      borderRadius: 5,
      boxShadow: ' 0px 0px 8px 0px rgba(0, 0, 0, 0.15)',

      '@media (max-width: 850px)': {
        minWidth: 'calc(100vw - 40px)',
      },
      '@media (max-height: 700px)': {
        overflowY: 'auto',
      },
    },
    xs: {
      minWidth: 700,
      maxWidth: 700,
      minHeight: 404,
    },
    xl: {
      minWidth: 800,
      maxWidth: 800,
      minHeight: 404,
    },
    rankWide: {
      minWidth: 1124,
      maxWidth: 1124,
      minHeight: 404,
      '@media (max-width: 960px)': {
        minWidth: 'calc(100vw - 40px)',
        maxWidth: 'calc(100vw - 40px)',
      },
    },
    modal_title: {
      display: '-webkit-box',
      '-webkit-line-clamp': 10,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 14,
      '&:not(:last-child)': {
        marginBottom: 5,
      },
      '& span': {
        color: '#000',
      },
    },
    modal_warning: {
      color: 'orange',
      marginTop: '15px',
      '& span': {
        fontWeight: 700,
        textTransform: 'uppercase',
      },
    },
    wrapper_header: {
      '& span': {
        display: 'inline-block',
        fontWeight: 700,
        fontSize: 14,
        marginRight: 5,
      },
      display: 'flex',
      alignItems: 'flex-start',
      gap: 10,
      padding: '0 48px 0 13px',
      fontWeight: 400,
      fontSize: 14,
    },
    close_button: {
      background: 'transparent',
      outline: 'none',
      border: 0,
      cursor: 'pointer',
      position: 'absolute !important',
      right: 20,
      width: 20,
      height: 20,
      zIndex: 10,
      padding: 0,

      '&:hover': {
        opacity: 0.7,
      },
      svg: {
        width: 20,
        height: 20,
      },
    },
    wrapper_body: {
      fontSize: 14,
      padding: '0 13px',
    },
    body_table: {
      height: '300px',
      overflowY: 'auto',
      position: 'relative',

      '&::-webkit-scrollbar': {
        width: 3,
      },

      '&::-webkit-scrollbar-thumb': {
        background: '#1A0063',
      },

      '&::-webkit-scrollbar-track': {
        width: 3,
      },

      '&::-webkit-scrollbar-thumb:hover': {
        width: 10,
      },
    },
    body_table_header: {
      fontWeight: 800,

      '&  > div': {
        paddingTop: 0,
        paddingRight: 4,
        borderBottom: '1px solid rgba(196, 196, 196, 1)',
      },
    },
    wrapper_footer: {
      marginTop: 'auto',
      display: 'flex',
      justifyContent: 'space-between',
    },

    row: {
      padding: '13px 5px',
      borderBottom: '1px solid rgba(196, 196, 196, 0.50)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& >*:nth-child(1)': {
        width: '50%',
      },
      '& >*:nth-child(2)': {
        width: '10%',
        display: 'flex',
        justifyContent: 'center',
      },
      '& >*:nth-child(3)': {
        width: '10%',
        display: 'flex',
        justifyContent: 'center',
      },
      '& >*:nth-child(4)': {
        width: '13%',
        display: 'flex',
        justifyContent: 'center',
      },
    },
    empty_msg: {
      width: '100%',
      textAlign: 'center',
      margin: '50px 0 0',
    },
    save_btn: {
      fontSize: '16px !important',
      fontWeight: '700 !important',
      textTransform: 'unset !important',
      background: '#1A0063 !important ',
      minHeight: '30px !important',
      padding: '0px 10px !important',
      '&:disabled': {
        opacity: 0.5,
      },
    },
    create: {
      display: 'flex',
      gap: 6,
      textTransform: 'unset !important',
      fontSize: '10px !important',
      fontWeight: '700 !important',
      minHeight: '30px !important',
      padding: '0px 10px !important',
      '&:hover': {
        '& svg': {
          filter: 'brightness(0) invert(1)',
        },
      },
      svg: {
        width: 16,
        height: 16,
      },
    },
    new_keyword: {
      display: 'flex',
      alignItems: 'center',
      gap: 3,
      '& input': {
        padding: 5,
      },
    },
    tabs_wrapper: {
      position: 'relative',
      zIndex: 1,

      '&::after': {
        position: 'absolute',
        left: 0,
        top: 15,
        zIndex: -1,
        width: 'calc(100%)',
        height: 'calc(100% - (var(--footer-height, 63px) + 33px))',
        border: '1px solid #1A0063',
        borderRadius: '10px',
        content: '""',
      },
      '& [role="tabpanel"]': {
        height: '100%',
      },
    },
    tabs_list: {
      width: '100%',
      minHeight: '30px !important',
      padding: '0 40px',
      '& .MuiTabs-indicator': {
        display: 'none',
      },
      '& [role="tablist"]': {
        width: '100%',
        display: 'flex',
        gap: 10,
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& button': {
        width: 'auto',
        minHeight: 30,
        padding: '0px 10px',
        fontSize: 14,
        fontWeight: 800,
        borderRadius: 5,
        textTransform: 'unset',
        '&[aria-selected="false"]': {
          color: 'rgba(0, 0, 0, 0.5)',
          background: '#FFFFFF',
          border: '1px solid #C4C4C4',
        },
        '&[aria-selected="true"]': {
          color: '#fff',
          background: '#1A0063',
        },
      },
    },
    panel_wrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
      paddingTop: 24,
      height: '100%',
    },
    categories_dropdown: {
      // position: 'absolute',
      // left: 0,
      // top: '90%',
      marginTop: 10,
      marginLeft: -5,
      // width: 'calc(100% + 10px)',
      // maxWidth: 353,
      width: 374,
      // zIndex: 10,
      background: '#E2E8F0',
      borderRadius: 5,
      padding: '10px 2px',
      maxHeight: 246,
      overflowY: 'auto',

      '&::-webkit-scrollbar': {
        width: 3,
      },

      '&::-webkit-scrollbar-thumb': {
        background: '#1A0063',
      },

      '&::-webkit-scrollbar-track': {
        width: 3,
      },

      '&::-webkit-scrollbar-thumb:hover': {
        width: 10,
      },

      '& [role="progressbar"]': {
        left: 'calc(50% - 20px)',
      },
    },
    categories_dropdown_inner: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      width: '100%',

      '& > div': {
        width: '100%',
        padding: '10px 8px',
        minHeight: 39,
        '&:not(:last-child)': {
          borderBottom: '1px solid #FFFFFF',
        },
      },
    },
    category_row: {
      position: 'relative',
    },
    category_item: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 20,
      width: '100%',
      fontSize: 12,
    },
    add_button: {
      background: 'transparent',
      borderRadius: '50%',
      width: 15,
      minWidth: 15,
      height: 15,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #000',
      cursor: 'pointer',
      '&:hover': {
        opacity: 0.5,
      },
    },
    center: {
      textAlign: 'center',
      margin: 'auto',
    },
  })
)
export default useStyles
